import domClick from './definitions/domClick'
import domFill from './definitions/domFill'
import domSelectOption from './definitions/domSelectOption'
import navigateToNewPlan from './definitions/navigateToNewPlan'
import navigateToPlan from './definitions/navigateToPlan'
import navigateToStudentPlan from './definitions/navigateToStudentPlan'
import navigateToTemplate from './definitions/navigateToTemplate'
import { ClientTool } from './Tool'

/**
 * Every client-side tool the assistant can dispatch. The runtime looks up tools
 * here by name when a DOM_TOOL_CALL event arrives. Adding a new tool is one
 * import + one entry in this list.
 */
export const CLIENT_TOOLS: readonly ClientTool[] = [
  navigateToStudentPlan,
  navigateToPlan,
  navigateToNewPlan,
  navigateToTemplate,
  domFill,
  domClick,
  domSelectOption
]

/**
 * Looks up a tool by name. Returns undefined if no tool matches — the runtime
 * silently skips unknown tool names rather than throwing, since tool support
 * may differ across client/server versions.
 */
export function getTool(name: string): ClientTool | undefined {
  return CLIENT_TOOLS.find((t) => t.name === name)
}
